import { createContext, useContext } from 'react';
import { assertEnabledApi } from '../../util';
export var SentryContext = createContext(null);
export var SentryProvider = SentryContext.Provider;
export var useSentry = function () {
    var sentry = useContext(SentryContext);
    assertEnabledApi(sentry, 'Sentry');
    return sentry;
};
//# sourceMappingURL=SentryProvider.js.map